import { render, staticRenderFns } from "./WidgetWrap.vue?vue&type=template&id=dcb5ca68&scoped=true"
import script from "./WidgetWrap.vue?vue&type=script&lang=ts"
export * from "./WidgetWrap.vue?vue&type=script&lang=ts"
import style0 from "./WidgetWrap.vue?vue&type=style&index=0&id=dcb5ca68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb5ca68",
  null
  
)

export default component.exports